var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11C3.5 6.58172 7.08172 3 11.5 3H48.5C52.9183 3 56.5 6.58172 56.5 11V48C56.5 52.4183 52.9183 56 48.5 56H11.5C7.08172 56 3.5 52.4183 3.5 48V11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0466 40.868L39.6124 31.1763C40.8347 29.607 41.5864 27.7323 41.7826 25.7643C41.9788 23.7964 41.6117 21.8137 40.7226 20.0404C39.8336 18.2671 38.4581 16.7741 36.7519 15.7301C35.0456 14.6861 33.0766 14.1328 31.0674 14.1328C29.0583 14.1328 27.0893 14.6861 25.383 15.7301C23.6768 16.7741 22.3013 18.2671 21.4123 20.0404C20.5232 21.8137 20.156 23.7964 20.3522 25.7643C20.5484 27.7323 21.3002 29.607 22.5225 31.1763L30.0883 40.868C30.2054 41.013 30.3544 41.1301 30.5239 41.2105C30.6934 41.291 30.8792 41.3328 31.0674 41.3328C31.2557 41.3328 31.4415 41.291 31.611 41.2105C31.7805 41.1301 31.9294 41.013 32.0466 40.868ZM25.8514 24.7324C25.8526 23.7204 26.1585 22.7314 26.7306 21.8906C27.3027 21.0497 28.1152 20.3946 29.0655 20.0081C30.0158 19.6216 31.0612 19.5211 32.0695 19.7192C33.0778 19.9173 34.0038 20.4052 34.7305 21.1212C35.4571 21.8372 35.9518 22.7491 36.152 23.7417C36.3521 24.7344 36.2488 25.7631 35.8551 26.698C35.4613 27.6328 34.7948 28.4318 33.9398 28.9939C33.0848 29.556 32.0797 29.856 31.0514 29.856C30.3681 29.856 29.6914 29.7235 29.0601 29.4659C28.4289 29.2083 27.8554 28.8308 27.3724 28.355C26.8895 27.8791 26.5066 27.3143 26.2456 26.6927C25.9846 26.0711 25.8507 25.4049 25.8514 24.7324Z",
    fill: "#3B968B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8784 37.2948C24.4964 37.1957 24.9171 36.6144 24.818 35.9963C24.7189 35.3783 24.1375 34.9576 23.5195 35.0567L23.8784 37.2948ZM38.6513 35.2658C38.0372 35.1448 37.4413 35.5446 37.3203 36.1587C37.1994 36.7728 37.5991 37.3687 38.2132 37.4897L38.6513 35.2658ZM44.099 40.1984C44.099 40.288 44.0368 40.5889 43.4078 41.0465C42.8035 41.4861 41.8562 41.9292 40.5837 42.3208C38.0525 43.0996 34.4868 43.5984 30.499 43.5984V45.8651C34.6481 45.8651 38.4491 45.3491 41.2503 44.4872C42.644 44.0584 43.8544 43.5246 44.7412 42.8795C45.6032 42.2524 46.3656 41.3607 46.3656 40.1984H44.099ZM30.499 43.5984C26.5111 43.5984 22.9454 43.0996 20.4142 42.3208C19.1417 41.9292 18.1944 41.4861 17.5902 41.0465C16.9611 40.5889 16.899 40.288 16.899 40.1984H14.6323C14.6323 41.3607 15.3947 42.2524 16.2567 42.8795C17.1436 43.5246 18.3539 44.0584 19.7476 44.4872C22.5489 45.3491 26.3498 45.8651 30.499 45.8651V43.5984ZM16.899 40.1984C16.899 40.134 16.9236 39.975 17.1686 39.7139C17.4191 39.447 17.8406 39.1417 18.4686 38.8297C19.7216 38.2073 21.5817 37.6631 23.8784 37.2948L23.5195 35.0567C21.1018 35.4445 18.9952 36.0372 17.4602 36.7998C16.6941 37.1803 16.0162 37.6296 15.5158 38.1628C15.01 38.7018 14.6323 39.3884 14.6323 40.1984H16.899ZM38.2132 37.4897C40.1987 37.8808 41.7729 38.4057 42.8196 38.9814C43.9546 39.6056 44.099 40.07 44.099 40.1984H46.3656C46.3656 38.7219 45.1547 37.6788 43.912 36.9953C42.5811 36.2633 40.7553 35.6803 38.6513 35.2658L38.2132 37.4897Z",
    fill: "#3B968B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4H48.5V2H11.5V4ZM55.5 11V48H57.5V11H55.5ZM48.5 55H11.5V57H48.5V55ZM4.5 48V11H2.5V48H4.5ZM11.5 55C7.63401 55 4.5 51.866 4.5 48H2.5C2.5 52.9706 6.52944 57 11.5 57V55ZM55.5 48C55.5 51.866 52.366 55 48.5 55V57C53.4706 57 57.5 52.9706 57.5 48H55.5ZM48.5 4C52.366 4 55.5 7.13401 55.5 11H57.5C57.5 6.02944 53.4706 2 48.5 2V4ZM11.5 2C6.52944 2 2.5 6.02944 2.5 11H4.5C4.5 7.13401 7.63401 4 11.5 4V2Z",
    fill: "#2E2D29",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.5,
    y: 0,
    width: 83,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.96ae6351edb14b311286fef12e9744a5.svg";
export { ForwardRef as ReactComponent };